import { render, staticRenderFns } from "./Addemp.vue?vue&type=template&id=8faaa82e&scoped=true"
import script from "./Addemp.vue?vue&type=script&lang=js"
export * from "./Addemp.vue?vue&type=script&lang=js"
import style0 from "./Addemp.vue?vue&type=style&index=0&id=8faaa82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faaa82e",
  null
  
)

export default component.exports